import { HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutLbReasonsPanel extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelDetails: Label;
    labelLoadBoardError: Label;
    labelReasons: Label;
    lbReasonsPanel: Panel;
}
